import { Masonry } from '@leagueplatform/masonry';
import { CASE_MANAGEMENT_ROOT_NODE_ID } from 'common/constants';
import { MasonryPageContainer } from '../masonry-container.page';

export const CaseManagementPage = () => (
  <MasonryPageContainer>
    <Masonry rootNodeId={CASE_MANAGEMENT_ROOT_NODE_ID} />
  </MasonryPageContainer>
);
